'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RdlDiffusion = exports.RdlTemplates = exports.RaceDayLive = undefined;

var _templates = require('./templates');

var _templates2 = _interopRequireDefault(_templates);

var _diffusion = require('./diffusion');

var _diffusion2 = _interopRequireDefault(_diffusion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RaceDayLive = function RaceDayLive() {
    var factory = this;

    var templates = _templates2.default;
    var local = {
        data: [], // private array with raw data items
        listKeys: [], // private array used to sort items
        historyList: [], // private array for store data from history response
        knownWarnings: {}, // topics that was handled by meeting filter function
        inQueue: [] // private array for store data from diffusion LE response
    };
    var list = {}; // public collection of items, rendered and ready to display (or partially displayed yet)
    var config = {
        contentSelector: '#rdl-content',
        messageNoPostsSelector: '.js-rdl-noPosts',
        bottomSpinner: $(templates.buttons.footSpinner),
        headerSpinner: $(templates.buttons.headSpinner),
        headerNewButtonBox: $(templates.buttons.upload),
        bottomStopElementSelector: '.ui-footer',
        outerLinks: {
            initial: 'https://events.racingpost.com/initial.sd?id=1',
            history: 'https://events.racingpost.com/history.sd?id=1',
            eventBody: 'https://events.racingpost.com/event_body.sd?id=',
            eventHeader: 'https://events.racingpost.com/event_header.sd?id='
        },
        courseLink: '/racecards/',
        links: { // mapper to meetings filter
            0: 'betting',
            5: 'latest',
            26: 'quote',
            20: 'mostTipped',
            16: 'latest',
            10: 'results',
            19: 'backed',
            11: 'hot',
            12: 'hot',
            13: 'hot',
            82: 'comm'
        },
        linksKey: { // mapper to meetings filter aliases
            0: 'betting',
            'Q': 'quote',
            'MT': 'mostTipped',
            'LR': 'latest',
            'CE': 'latest',
            'MB': 'backed',
            'HC': 'hot',
            'HJ': 'hot',
            'HT': 'hot',
            'LC': 'comm',
            'FRR': 'results'
        },
        imagesDomain: 'https://www.rp-assets.com',
        assetsDomain: 'https://www.rp-assets.com',
        currentFilter: '', // courses filter, integer
        maximumTopicsInList: 9999999, // maximum number topics that can be showed (999999 cuz some problems with Number.MAX_SAFE_INTEGER)
        buttonOnlyAtTop: false, // remove sticky function from button when scrolling
        startRangeForTopics: 20, // initial number of posts to show
        historyUpload: true, // load additional posts from history on scroll down
        newUpload: true, // load new posts
        updateRangeForOldTopics: 10, // +X posts every scroll down
        adaptForExNarrowLayout: false, // at ex-wide breakpoint and ex-narrow container size ui has different displaying
        filterCoursesFunction: function filterCoursesFunction(filter, data) {
            data = typeof data.rawData !== 'undefined' ? data.rawData : data;
            if (Object.keys(data).length === 0) {
                console.log('Empty event response');
                return false;
            }
            var courseId = typeof data.courseId !== 'undefined' ? parseInt(data.courseId, 10) : '';
            return courseId !== 0 && (filter === '' || courseId === filter);
        },
        onInitCallback: function onInitCallback() {},
        onUpdateCallback: function onUpdateCallback() {}
    };

    var init = function init(options) {
        config = $.extend(config, options);
        $('.rdl-content').attr('data-price-location', 'Raceday Live');
        // Setting date for priceComponent
        $(config.contentSelector).attr('data-diffusion-racedate', new Date().toISOString().substr(0, 10));
        // Adding buttons and other
        $(config.contentSelector).before(config.headerNewButtonBox).before(config.headerSpinner).after(config.bottomSpinner);
        config.headerNewButton = $('.rdl-uploadBtn');

        // handle other
        handleFilterChange();
        handleNewPostsBtnClick();
        if (config.historyUpload) {
            handleAutoUpload();
        }

        var hash = window.location.hash.replace('#', '');
        if (hash !== 'meet0' && hash !== '') {
            config.currentFilter = parseInt(hash.replace('meet', ''), 10);
        }

        config.headerSpinner.show();
        setDataInitial(function () {
            config.headerSpinner.hide();
            showAll();
            appendNoPostsMessage();
            config.onInitCallback();
            if (config.newUpload) {
                initLive();
            }
        });

        return this;
    };

    var initLive = function initLive() {
        new _diffusion2.default($, {
            topicName: 'LIVE_EVENT/1',
            callbackLE: function callbackLE(id, type) {
                addNewData({ id: id, type: type });
                $.event.trigger('dynamicPricesUpdated.PRICES');
            }
        });
    };

    function handleFilterChange() {
        $(window.document).on('filter.apply', function (event, filter) {
            if (!filter) {
                window.location.hash = '';
            } else {
                window.location.hash = 'meet' + filter;
            }
            setFilter(filter);
            purge();
            config.headerSpinner.show();
            setDataInitial(function () {
                sort();
                config.headerSpinner.hide();
                showAll(config.startRangeForTopics);
                $.event.trigger('dynamicPricesUpdated.PRICES');
            });
            if (config.headerNewButtonBox.is(':visible')) {
                goNewPosts();
                event.stopPropagation();
            }
        });
    }

    function hideButton() {
        config.headerNewButtonBox.removeClass('rdl-uploadBox-active');
        config.headerNewButtonBox.removeClass('rdl-uploadBox-fixed');
        $(config.contentSelector).css({ 'margin-top': 0 });
    }

    function goNewPosts() {
        hideButton();
        config.headerSpinner.show();
        getTopicList(local.inQueue, getCountItems() + local.inQueue.length, function () {
            renderAll(local.inQueue);
            local.inQueue = [];
            sort();
            purge();
            config.headerSpinner.hide();
            showAll();
            if ($(window).scrollTop() > $(config.contentSelector).offset().top + config.headerNewButtonBox.height()) {
                $('body').animate({ scrollTop: $(config.contentSelector).offset().top }, 200);
            }

            $.event.trigger('dynamicPricesUpdated.PRICES');
            config.onUpdateCallback();
        });
    }

    function handleNewPostsBtnClick() {
        config.headerNewButtonBox.width(config.headerNewButtonBox.parent().width());
        config.headerNewButton.on('click', function () {
            goNewPosts();
        });
    }

    function handleAutoUpload() {
        $(window).resize(function () {
            config.headerNewButtonBox.width(config.headerNewButtonBox.parent().width());
        });
        $(window).scroll(function () {
            if (checkVisible($(config.bottomStopElementSelector))) {
                enhanceData();
            }

            changeButtonPosition();
        });
    }

    function changeButtonPosition() {
        $(config.contentSelector).css({ 'margin-top': 72 });
        if (config.headerNewButtonBox.is(':visible')) {
            if (!config.buttonOnlyAtTop) {
                var isPositionFixed = config.headerNewButtonBox.hasClass('rdl-uploadBox-fixed');
                var isButtonDeeperThanContent = $(config.contentSelector).outerHeight() + $(config.contentSelector).offset().top - $(window).scrollTop() <= 0;
                if (!isPositionFixed && $(window).scrollTop() >= $(config.contentSelector).offset().top && !isButtonDeeperThanContent && !config.buttonOnlyAtTop) {
                    config.headerNewButtonBox.removeClass('rdl-uploadBox-active');
                    config.headerNewButtonBox.addClass('rdl-uploadBox-fixed');
                }
                if (isPositionFixed && ($(window).scrollTop() <= $(config.contentSelector).offset().top - config.headerNewButtonBox.outerHeight() || isButtonDeeperThanContent)) {
                    config.headerNewButtonBox.removeClass('rdl-uploadBox-fixed');
                    config.headerNewButtonBox.addClass('rdl-uploadBox-active');
                }
            }
        } else {
            hideButton();
        }
    }

    var setDataInitial = function setDataInitial(callback) {
        config.headerSpinner.show();
        sort();
        $.get(config.outerLinks.initial, function (data) {
            data = JSON.parse(data);
            renderAll(data);
            var limit = Math.min(config.startRangeForTopics, config.maximumTopicsInList);
            if (getCountItems() < limit && config.historyUpload) {
                setDataHistory(callback, limit);
            } else {
                callback();
            }
        });

        return this;
    };

    var setDataHistory = function setDataHistory(callback, limit) {
        local.data = [];
        sort();

        // if there wan't change of filter, we don't need to renew history data, cuz local.data has all actual items
        if (local.historyList.length === 0) {
            $.get(config.outerLinks.history, function (items) {
                items = items ? JSON.parse(items) : [];
                local.historyList = Array.isArray(items) ? items : [];
                getTopicList(items, limit, callback);
            });
        } else {
            getTopicList(local.historyList, limit, callback);
        }
    };

    var getTopicList = function getTopicList(historyItems, limit, callback) {
        var deferred = [];

        // creating array of deferred objects (events)
        var getDeferred = function getDeferred(item) {
            return $.get(config.outerLinks.eventHeader + item.i, function (data) {
                local.data.push(JSON.parse(data));
            });
        };

        // cycle of adding to deferred object pull
        for (var item, i = 0, j = getCountItems(), to = historyItems.length; i < to && j < limit; i++) {
            if (filterMeetingsFunction(historyItems[i]) && typeof list[historyItems[i].i] === 'undefined') {
                j++;
                if (typeof historyItems[i].eventId !== 'undefined') {
                    local.data.push(historyItems[i]);
                } else {
                    deferred.push(getDeferred(historyItems[i]));
                }
            }
        }

        if (deferred.length > 0) {
            // after resolving all deferred objects we can work with them
            $.when.apply($, deferred).always(function () {
                renderAll();
                callback();
            });
        } else {
            callback();
        }
    };

    var enhanceData = function enhanceData() {
        if (getCountItems() < config.maximumTopicsInList) {
            config.bottomSpinner.show();

            var limit = Math.min(getCountItems() + config.updateRangeForOldTopics, config.maximumTopicsInList);
            setDataHistory(function () {
                sort();
                config.bottomSpinner.hide();
                showAll(limit);
                $.event.trigger('dynamicPricesUpdated.PRICES');
            }, limit);
        }
    };

    var getCountItems = function getCountItems() {
        var total = 0;

        for (var i = 0; i < local.listKeys.length; i++) {
            if (config.filterCoursesFunction(config.currentFilter, list[local.listKeys[i]])) {
                total++;
            }
        }
        return total;
    };

    var setFilter = function setFilter(filter) {
        config.currentFilter = filter ? parseInt(filter, 10) : '';
    };

    /**
     * Generates url to race card.
     *
     * @example https://www.racingpost.com/racecards/1083/chelmsford-aw/2016-12-19/664011
     *
     * @param id
     * @param name
     * @param date
     * @param rid
     * @returns {string}
     */
    var generateRaceCardUrl = function generateRaceCardUrl(id, name, date, rid) {
        return config.courseLink + id + '/' + name.toLowerCase().replace(/\./, '').replace(/\((?!aw)[a-z]{2,3}\)/, '').replace(/[^\w\s\-]/ig, '').trim().replace(/[\s_]+/g, '-') + '/' + date + '/' + rid;
    };

    /**
     * This method generates link to page where single course shown: list of race cards.
     *
     * @example https://www.racingpost.com/racecards/1083/chelmsford-aw/2016-12-19
     *
     * @param id
     * @param name
     * @param date
     * @param rid
     * @returns {string}
     */
    var generateCourseUrlBigScreen = function generateCourseUrlBigScreen(id, name, date, rid) {
        if (rid) {
            return generateRaceCardUrl(id, name, date, rid);
        }
        return config.courseLink + id + '/' + name.toLowerCase().replace(/\./, '').replace(/\((?!aw)[a-z]{2,3}\)/, '').replace(/[^\w\s\-]/ig, '').trim().replace(/[\s_]+/g, '-') + '/' + date;
    };

    /**
     * This method generates link to page where list of courses shown: list of courses with correspondent race cards.
     *
     * @example https://www.racingpost.com/racecards/#chelmsford-aw
     *
     * @param id
     * @param name
     * @param date
     * @param rid
     * @returns {string}
     */
    var generateCourseUrlSmallScreen = function generateCourseUrlSmallScreen(id, name, date, rid) {
        if (rid) {
            return generateRaceCardUrl(id, name, date, rid);
        }
        return config.courseLink + '#' + name.toLowerCase().replace(/\./, '').replace(/\((?!aw)[a-z]{2,3}\)/, '').replace(/[^\w\s\-]/ig, '').trim().replace(/[\s_]+/g, '-');
    };

    var getTopicRendered = function getTopicRendered(id) {
        var isExist = false;
        for (var i = 0, to = local.listKeys.length; i < to; i++) {
            if (parseInt(local.listKeys[i], 10) === parseInt(id, 10)) {
                isExist = list[id];
                break;
            }
        }
        return isExist;
    };

    function addNewData(data) {
        data = { i: parseInt(data.id, 10), t: data.type };

        if (!data.i) {
            return false;
        }

        $.get(config.outerLinks.eventHeader + data.i).success(function (result) {
            result = JSON.parse(result);
            var existItem;
            if (existItem = getTopicRendered(result.eventId)) {
                existItem.renew(result);
                $.event.trigger('dynamicPricesUpdated.PRICES');
            } else {
                var newQueue = findNotShownPost(local.inQueue, data.i);
                var historyQueue = findNotShownPost(local.historyList, data.i);
                if (newQueue && newQueue >= 0) {
                    local.inQueue[newQueue] = result;
                    $.event.trigger('dynamicPricesUpdated.PRICES');
                } else if (historyQueue && historyQueue >= 0) {
                    //just ignore cuz any data about it is not loaded
                } else if (config.filterCoursesFunction(config.currentFilter, result)) {
                    local.historyList.unshift(data);
                    local.inQueue.unshift(result);

                    $(config.messageNoPostsSelector).hide();
                    config.headerNewButtonBox.addClass('rdl-uploadBox-active');

                    changeButtonPosition();
                }
            }
        });

        return true;
    }

    function findNotShownPost(array, desiredValue) {
        var predicate = function predicate(arrayItem) {
            return arrayItem.i === desiredValue;
        };
        return array.findIndex(predicate);
    }

    function purge() {
        $(config.contentSelector).empty();
    }

    function sort() {
        local.listKeys.sort(function (a, b) {
            var timeB = list[b].rawData.releaseTime || list[b].rawData.postedAt * 1000;
            var timeA = list[a].rawData.releaseTime || list[a].rawData.postedAt * 1000;
            return parseInt(timeB, 10) - parseInt(timeA, 10);
        });

        return factory;
    }

    function filterMeetingsFunction(data) {
        if (Object.keys(data).length == 0) {
            // Skipping empty Event
            return false;
        }

        data = typeof data.rawData !== 'undefined' ? data.rawData : data;
        var key = data.t ? data.t : typeof data.typeKey !== 'undefined' ? data.typeKey : false;
        var result = key && typeof config.linksKey[key] !== 'undefined';
        if (!result && typeof local.knownWarnings[key] === 'undefined') {
            local.knownWarnings[key] = [];
            console.log('Unknown Type of Event: ' + key + '. JSON Item: ', data);
        }
        if (!result) {
            local.knownWarnings[key].push(data);
        }
        return result;
    }

    function showAll(limit, filterCoursesFunction) {
        filterCoursesFunction = filterCoursesFunction || config.filterCoursesFunction;
        if (!limit) {
            limit = 9999999;
        }
        limit = Math.min(limit, local.listKeys.length, config.maximumTopicsInList);

        for (var i = 0, cur = 0; cur < limit && i < local.listKeys.length; i++) {
            if (filterCoursesFunction(config.currentFilter, list[local.listKeys[i]]) && !list[local.listKeys[i]].$html.is(':visible')) {
                list[local.listKeys[i]].apply();
                cur++;
            }
        }
        return factory;
    }

    function appendNoPostsMessage(to) {
        var $html = $(templates.messages.noPosts).clone().hide();
        $html.appendTo(to || $(config.contentSelector));
        if (config.adaptForExNarrowLayout) {
            $html.addClass('rdl-narrowContainer');
        }

        if (local.listKeys.length === 0) {
            $html.show();
        }
    }

    function renderAll(data) {
        data = data || local.data;

        var item;

        for (var i = 0, to = data.length; i < to; i++) {
            // only if we have no that rendered item
            // and it satisfies Meeting filters
            if (typeof list[data[i].eventId] === 'undefined' && filterMeetingsFunction(data[i])) {
                item = create(data[i]);
                if (item !== null) {
                    list[item.id] = item.render();
                    if (local.listKeys.indexOf(item.id) === -1) {
                        local.listKeys.push(item.id);
                    }
                }
            }
        }
        return factory;
    }

    // helper function to check visibility of element
    function checkVisible(elm) {
        var vpH = $(window).height(),
            st = $(window).scrollTop(),
            y = $(elm).offset().top,
            h = $(elm).height();
        return y + h > st && y < vpH + st;
    }

    // helper function that return pretty time format from current moment
    /*
    * @param date - date of event
    * @param currentDate - date which can be set as current (for testing mainly)
    * Helper function that return pretty time format from current moment
    */
    var timeSince = function timeSince(date, currentDate) {
        currentDate = currentDate || new Date();
        var seconds = Math.floor((currentDate - date) / 1000);
        var interval = Math.floor(seconds / 31536000);

        if (interval >= 1) {
            return interval + ' year' + (interval > 1 ? 's' : '');
        }
        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
            return interval + ' month' + (interval > 1 ? 's' : '');
        }
        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
            return interval + ' day' + (interval > 1 ? 's' : '');
        }
        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
            return interval + ' hour' + (interval > 1 ? 's' : '');
        }
        interval = Math.floor(seconds / 60);
        if (interval >= 1) {
            return interval + ' minute' + (interval > 1 ? 's' : '');
        }
        return Math.floor(seconds) + ' second' + (Math.floor(seconds) > 1 ? 's' : '');
    };

    var create = function create(element) {
        var name = 'create' + config.linksKey[element.typeKey].charAt(0).toUpperCase() + config.linksKey[element.typeKey].slice(1);
        return createMethods[name](element);
    };

    var ModelProto = function ModelProto(data, selector) {
        var id = data.eventId || null;
        var $html = $(templates.patterns[selector]).clone();
        var time = timeSince(data.releaseTime || data.postedAt * 1000) + ' ago';
        var canCreateLink = data.courseId && data.courseName;
        var now = new Date();
        var date = data.raceDate || now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2);

        if (id !== null) {
            $html.attr('id', 'rdl-id-' + id);
        }
        $html.find('.js-rdl-time').html((data.byline ? data.byline + ' - ' : '') + time);

        var ret = {
            id: id,
            updated: false,
            $html: $html,
            rawData: data,
            time: time,
            by: data.byline || '',
            header: data.header || '',
            ico: data.image || '',
            body: data.story || data.synopsis || '',
            outerLinkTitle: canCreateLink ? (data.raceTime ? data.raceTime + ' ' : '') + data.courseName : '',
            outerLinkUrlBigScreen: canCreateLink ? generateCourseUrlBigScreen(data.courseId, data.courseName, date, data.raceId) : '', // link to single course
            outerLinkUrlSmallScreen: canCreateLink ? generateCourseUrlSmallScreen(data.courseId, data.courseName, date, data.raceId) : '', // link to list of courses
            betTitle: data.horseName || '',
            betBody: ((data.raceTime || '') + ' ' + (data.courseName || '')).trim(),
            buttons: [],

            // in question of
            namesWithComments: data.commentList || [],

            apply: function apply(to) {
                this.$html.appendTo(to || $(config.contentSelector));
                return this;
            },
            renew: function renew(data) {
                var newItem = create(data);
                newItem.render();
                $.extend(this, newItem);
                $('#rdl-id-' + this.id).replaceWith(newItem.$html);

                return this;
            },
            appendButtons: function appendButtons() {
                if (typeof this.rawData.inlinePrice !== 'undefined') {
                    var $html = this.$html;
                    this.buttons.forEach(function (btn) {
                        btn.appendTo($html.find('.rdl-itemContent'));
                    });
                    $html.find('.rdl-itemContent').addClass('js-PC-runnerRow');
                }
            }
        };

        setInterval(function () {
            ret.time = timeSince(data.releaseTime || data.postedAt * 1000) + ' ago';
            $html.find('.js-rdl-time').html((data.byline ? data.byline + ' - ' : '') + ret.time);
        }, 60000);

        return ret;
    };

    var createMethods = {
        parentConfig: config,

        createButtons: function createButtons(data) {
            if (typeof data.rawData.inlinePrice !== 'undefined') {
                if (data.rawData.inlinePrice.length > 0) {
                    for (var i = 0, count = data.rawData.inlinePrice.length; i < count; i++) {
                        if (data.rawData.inlinePrice[i].hasOwnProperty("diffusionCourseName")) {
                            data.buttons.push(createMethods.createButton(data, i));
                        }
                    }
                }
            }
            return data;
        },

        createButton: function createButton(data, inlinePriceIterator) {
            var $html = $(templates.patterns['button']).clone();

            function toTitleCase(str) {
                var pstr = str.replace(/\w\S*/g, function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
                return $('<div/>').html(pstr).text();
            }

            var actualData = data.rawData.inlinePrice[inlinePriceIterator];

            $html.attr('data-diffusion-coursename', actualData.diffusionCourseName).attr('data-diffusion-racetime', actualData.raceTime24).attr('data-diffusion-racedate', actualData.raceDate).attr('data-diffusion-horsename', toTitleCase(actualData.horseName.replace('&acute;', '&#039;'))) // replace ` with ' for priceConnector
            .attr('data-diffusion-race-id', actualData.raceId).addClass('js-diffusionHorsesList');

            $html.find('.rdl-addComm-title').html(actualData.horseName || '');
            $html.find('.rdl-addComm-body').html(actualData.raceTime ? actualData.raceTime + ' ' + actualData.courseName : '');

            return $html;
        },

        createQuote: function createQuote(data) {
            var selector = 'quote';
            var initData = new ModelProto(data, selector);

            return $.extend(initData, {
                render: function render() {
                    this.$html.find('.js-rdl-itemTitle').html(this.header);
                    this.$html.find('.js-rdl-body').html(this.body);

                    createMethods.createButtons(this).appendButtons();

                    return this;
                }
            });
        },

        createMostTipped: function createMostTipped(data) {
            var selector = 'mostTipped';
            var initData = new ModelProto(data, selector);

            return $.extend(initData, {
                render: function render() {
                    this.$html.find('.js-rdl-itemTitle').html(this.header);
                    this.$html.find('.js-rdl-body').html(this.body);

                    createMethods.createButtons(this).appendButtons();

                    return this;
                }
            });
        },

        createLatest: function createLatest(data) {
            var selector = 'latest';
            var initData = new ModelProto(data, selector);

            return $.extend(initData, {
                localConfig: this.parentConfig,
                render: function render() {
                    // For images of reporters  the Alt and the Title to be the name of the reporter (NEWS-1679)
                    var alt = this.by.replace('By ', '');

                    /*
                     * Change images domain as required in
                     * https://racingpost.atlassian.net/browse/NEWS-2071
                     */
                    this.ico = this.ico.replace(this.localConfig.imagesDomain, this.localConfig.assetsDomain);
                    this.$html.find('.rdl-ico').attr('src', this.ico).attr('alt', alt).attr('title', alt);
                    this.$html.find('.js-rdl-itemTitle').html(this.header);
                    this.$html.find('.js-rdl-body').html(this.body);

                    createMethods.createButtons(this).appendButtons();

                    if (this.outerLinkTitle !== '') {
                        // Link to page with list of courses
                        this.$html.find('.js-outerLink-hidden-md-up').prepend(this.outerLinkTitle).attr('href', this.outerLinkUrlSmallScreen);
                        // Link to page with single course
                        this.$html.find('.js-outerLink-hidden-sm-down').prepend(this.outerLinkTitle).attr('href', this.outerLinkUrlBigScreen);
                    } else {
                        this.$html.find('.rdl-outerLink').hide();
                    }

                    return this;
                }
            });
        },

        createResults: function createResults(data) {
            var selector = 'results';
            var initData = new ModelProto(data, selector);

            return $.extend(initData, {
                render: function render() {
                    this.$html.find('.js-rdl-itemTitle').html(this.header);
                    this.$html.find('.js-rdl-body').html(this.body);

                    createMethods.createButtons(this).appendButtons();

                    if (this.outerLinkTitle !== '') {
                        this.$html.find('.rdl-outerLink').prepend(this.outerLinkTitle).attr('href', this.outerLinkUrlBigScreen);
                    } else {
                        this.$html.find('.rdl-outerLink').hide();
                    }

                    return this;
                }
            });
        },

        createBacked: function createBacked(data) {
            var selector = 'backed';
            var initData = new ModelProto(data, selector);

            return $.extend(initData, {
                render: function render() {
                    this.$html.find('.js-rdl-itemTitle').html(this.header);

                    createMethods.createButtons(this).appendButtons();

                    return this;
                }
            });
        },

        createBetting: function createBetting(data) {
            var selector = 'betting';
            var initData = new ModelProto(data, selector);

            return $.extend(initData, {
                render: function render() {
                    this.$html.find('.js-rdl-itemTitle').html(this.header);
                    this.$html.find('.js-rdl-body').html(this.body);

                    createMethods.createButtons(this).appendButtons();

                    return this;
                }
            });
        },

        createHot: function createHot(data) {
            var selector = 'hot';
            var initData = new ModelProto(data, selector);

            return $.extend(initData, {
                render: function render() {
                    this.$html.find('.js-rdl-itemTitle').html(this.header);
                    this.$html.find('.js-rdl-body').html(this.body);

                    createMethods.createButtons(this).appendButtons();

                    return this;
                }
            });
        },

        createComm: function createComm(data) {
            var selector = 'comm';
            var initData = new ModelProto(data, selector);

            return $.extend(initData, {
                render: function render() {
                    var $to = this.$html.find('.rdl-post__body');
                    var $cloned = $to.find('.rdl-itemBodyList');
                    $to.empty();
                    for (var i = 0; i < this.namesWithComments.length; i++) {
                        var $copy = $cloned.clone();
                        $copy.find('.js-rdl-body').html(this.namesWithComments[i].body);
                        $to.append($copy);
                    }
                    $cloned.remove();

                    return this;
                }
            });
        }
    };

    return {
        purge: purge,
        sort: sort,
        showAll: showAll,
        list: list,
        init: init,
        setDataInitial: setDataInitial,
        setDataHistory: setDataHistory,
        config: config,
        setFilter: setFilter,
        enhanceData: enhanceData,
        addNewData: addNewData,
        changeButtonPosition: changeButtonPosition,
        // return this method for testing purposes
        _createMethods: createMethods,
        _timeSince: timeSince
    };
};

exports.RaceDayLive = RaceDayLive;
exports.RdlTemplates = _templates2.default;
exports.RdlDiffusion = _diffusion2.default;


//////////////////
// WEBPACK FOOTER
// ./~/rp-race-day-live/lib/js/raceDayLive.js
// module id = 1530
// module chunks = 1